import axios from 'axios';
import { deleteTerm } from './dealer';

const ON_ADDRESS_BLUR_STARTED = 'ON_ADDRESS_BLUR_STARTED';
const ON_ADDRESS_BLUR_FAILURE = 'ON_ADDRESS_BLUR_FAILURE';
const ON_ADDRESS_BLUR_SUCCESS = 'ON_ADDRESS_BLUR_SUCCESS';

const ON_ADDRESS_SELECT_STARTED = 'ON_ADDRESS_SELECT_STARTED';
const ON_ADDRESS_SELECT_FAILURE = 'ON_ADDRESS_SELECT_FAILURE';
const ON_ADDRESS_SELECT_SUCCESS = 'ON_ADDRESS_SELECT_SUCCESS';

const ON_ADDRESS_CHANGE = 'ON_ADDRESS_CHANGE';

export function onAddressChange(addressData) {
  return { type: ON_ADDRESS_CHANGE, payload: addressData }
}

export function onAddressBlur(addressData, contractId) {
  return (dispatch) => {
    dispatch(onAddressBlurStarted())

    axios.post(`/contracts/${contractId}/contract-address/`, addressData)
      .then(() => dispatch(deleteTerm(contractId)))
      .then(() => dispatch(onAddressBlurSuccess()))
      .catch((err) => dispatch(onAddressBlurFailure()))
  }
};

const onAddressBlurSuccess = () => ({ type: ON_ADDRESS_BLUR_SUCCESS });
const onAddressBlurStarted = () => ({ type: ON_ADDRESS_BLUR_STARTED });
const onAddressBlurFailure = (payload) => ({ type: ON_ADDRESS_BLUR_FAILURE, payload });

export function onAddressSelect(addressData, contractId) {
  return (dispatch) => {
    dispatch(onAddressSelectStarted())

    axios.post(`/contracts/${contractId}/contract-address/`, addressData)
      .then(() => dispatch(deleteTerm(contractId)))
      .then(() => dispatch(onAddressSelectSuccess(addressData)))
      .catch((err) => dispatch(onAddressSelectFailure()))
  }
};

const onAddressSelectSuccess = (addressData) => ({ type: ON_ADDRESS_SELECT_SUCCESS, payload: addressData });
const onAddressSelectStarted = () => ({ type: ON_ADDRESS_SELECT_STARTED });
const onAddressSelectFailure = (err) => ({ type: ON_ADDRESS_SELECT_FAILURE, payload: err });

function addressReducer(state, action) {
  switch (action.type) {
    case ON_ADDRESS_BLUR_STARTED:
      return {
        ...state,
        // loading: true,
      }
    case ON_ADDRESS_BLUR_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    case ON_ADDRESS_BLUR_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case ON_ADDRESS_CHANGE:
      return {
        ...state,
        address: {
          ...state.address,
          [action.payload.name]: action.payload.value,
        },
        term: {
          ...state.term,
          selected: null,
        }
      }
    case ON_ADDRESS_SELECT_STARTED:
      return {
        ...state,
        loading: true,
      }
    case ON_ADDRESS_SELECT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    case ON_ADDRESS_SELECT_SUCCESS:
      return {
        ...state,
        loading: false,
        address: action.payload,
        term: {
          ...state.term,
          selected: null,
        }
      }
    default:
      return state
  }

  return state;
}

export default addressReducer;
